import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Header from "./components/header";
import Footer from "./components/footer";
import Inverter from "./pages/inverter";  
import "./App.css";





const App = () => {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/inverter" element={<Inverter />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
